import angular, {IModule, IPromise, IQService} from "angular";
import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";

export interface DialogInterface {
    alert(tittel: string, innhold: string): angular.IPromise<any>;
    alertMedHtmlInnhold(tittel: string, htmlInnhold: string): angular.IPromise<any>;
    confirm(tittel: string, htmlInnhold: string, okLabel: string, cancelLabel: string): IPromise<any>;
}

export class DialogMock implements DialogInterface {
    static regNavn = "Dialog";

    constructor(private $q: IQService) {
    }

    alert(tittel: string, innhold: string): angular.IPromise<any> {
        return this.$q.reject();
    }

    alertMedHtmlInnhold(tittel: string, htmlInnhold: string): angular.IPromise<any> {
        return this.$q.reject();
    }

    confirm(tittel: string, htmlInnhold: string, okLabel: string, cancelLabel: string): angular.IPromise<any> {
        return this.$q.reject();
    }

    static registrerTjenester(angular: IModule) {
        angular
          .service(DialogMock.regNavn, DialogMock.forInjisering());
    }

    private static forInjisering() {
        return [regNavn.ng.$q, DialogMock]
    }
}
